import { useLocalStorage } from "@solana/wallet-adapter-react";
import { Navigate } from 'react-router-dom';

const BearerCheck = ({ children }: any) => {
    let [authorization, setAuthorization] = useLocalStorage<string[]>('authorization', ['authorization', '']);

    if(!authorization[1].startsWith("Bearer")) {
        return <Navigate to = '/' replace/>;
    }

    return children;
}

export default BearerCheck;